export const NavigationSymbol = Symbol('Navigation')
export const ShouldNavigateHandlerSymbol = Symbol('ShouldNavigateHandler')

export const name = 'navigation' as const
